export const REGISTER_FIELD_CHANGE = 'CHARGES/REGISTER_FIELD_CHANGE';
export const CHANGE_DATE = 'CHARGES/CHANGE_DATE';
export const CLEAR_FREQUENCY = 'CHARGES/CLEAR_FREQUENCY';
export const SET_CHARGES = 'CHARGES/SET_CHARGES';
export const SET_CHARGES_ERRORS = 'CHARGES/SET_CHARGES_ERRORS';
export const CLEAR_CHARGES_ERRORS = 'CHARGES/CLEAR_CHARGES_ERRORS';
export const HANDLE_LOADING = 'CHARGES/HANDLE_LOADING';
export const CLEAR_CHARGES = 'CHARGES/CLEAR_CHARGES';